import { useAuthContext } from './useAuthContext';
import { useContentsContext } from "../hooks/useContentsContext";
import Cookies from "js-cookie";
import { useState } from 'react';
import { useQuery } from 'react-query';
export const useContentGeneration = () => {

const[error] = useState();
    const { user } = useAuthContext()
    const users = Cookies.get('token')
    const { dispatchcontent } = useContentsContext()

    const sendContentGenerationRequest = async (data) => {

 


      if (data !== "" ) {
        const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/generate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            },
            body: JSON.stringify( data)
        })
        if(response.ok){
          return response
        }else if(response.status === 401){
          return "Reload the page to refresh the session."
         }else{
          return response
        }
    
       
       
    
  }

    }



    const fetchHistory = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/history`,{
          headers:{
            'Authorization': `Bearer ${users}`
          }
        });
 

        if(response.ok){
          const json =await response.json();
            return json
        }
      
      }
      const {data} = useQuery(
        "historyData",
        fetchHistory,
    
      
      )
      const allHistory = data

 const fetchSpecificHistory = async (param) => {
        const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/history/flash?contentType=${param}`,{
          
          headers:{
            'Authorization': `Bearer ${user}`
          }
        });
        
        if(response.status === 401){
         
      
         }else{
          const json = await response.json()
        if(response.ok){

            return json
        }
      }
      }


    const editGeneratedContent = async(uuid,data) =>{
    
  
        if(data !== ""){
            const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/edit-content/${uuid}`, {
                method: "PATCH",
                body: JSON.stringify(data),
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${user}`
                }
              })
              return response;
            //   const json = await response.json()
            //  return json
    
    }
  }


      const generateImage = async(data) =>{
        const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/generate/image-generation`,{
          method: "POST",
          body: JSON.stringify(data),
          headers:{
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user}`
          }
          
        })
        return response
    
    }
 
      const fetchImages = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/history/images`,{
          
          headers:{
            'Authorization': `Bearer ${users}`
          }
        });
        const json =await response.json();
        if(response.ok){
       
          dispatchcontent({ type: 'FETCH_CONTENTS', payload: json })
            return json
        }
      
      }
  //dynamic flash template

  const sendDynamicFlashTemRequest = async (data) => {

    if (data !== "" ) {
        const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/generate/dynamic`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            },
            body: JSON.stringify(data)
        })
        const json = response.json()
        if(response.ok){
          return json
        }
    
       
       if(response.status === 401){
        return "Reload the page to refresh the session."
       }
  
    
  }

}

      const saveDynamicTemplate = async (data) => {

        if (data !== "" ) {
            const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/save-custom-flash`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`
                },
                body: JSON.stringify(data)
            })
            const json = response.json()
            if(response.ok){
              return json
            }
        
           
           if(response.status === 401){
            return "Reload the page to refresh the session."
           }
      
        
      }
    
    }
    
    const sendCustomContentRequest = async (data) => {
    
      if (data !== "" ) {
          const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/generate/custom-content`, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${user}`
              },
              body: JSON.stringify( data)
          })
          if(response.ok){
            return response
          }else if(response.status === 401){
            return "Reload the page to refresh the session."
           }else{
            return response
          }
      
         
         
      
    }
    
    }
    



      //text to speech
      const sendTexttoSpeech = async(data)=>{
        const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/text-to-speech`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${user}`
          },
          body: JSON.stringify(data)
      })
      
      return response
      // const json = response.json()
      // if(response.ok){
      //   return json
      // }
          
      }
      
      

         const fetchTTS = async () => {
          const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/history/tts`,{
            method:"GET",
            headers:{
              'Authorization': `Bearer ${users}`
            }
          });
          const json =await response.json();
          if(response.ok){
      
            dispatchcontent({ type: 'FETCH_CONTENTS', payload: json })
              return json
          
        }
        }
      
      
        const fetchVoices = async () => {
          const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/voices`,{
            method:"GET",
            headers:{
              'Authorization': `Bearer ${users}`
            }
          });
          const json = await response.json()
          if(response.ok){
      
       
           return json
              
          
        }
        }
      
      
    return {allHistory,editGeneratedContent, sendContentGenerationRequest,fetchHistory,fetchSpecificHistory ,generateImage,fetchImages,error,sendTexttoSpeech,fetchTTS,fetchVoices,sendCustomContentRequest,saveDynamicTemplate,sendDynamicFlashTemRequest }
}

